'use client';
import styled from 'styled-components';
import { devices, theme } from 'styles/theme';

const Hamburger = ({open, close}) => {
    return (
        <StyledHamburger className={`menu-hamburger ${open ? 'open' : ''}`}>
            {
                close ?
                    <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.4852 9.00002L1.99995 1.00002" stroke="white" strokeWidth="2" strokeLinecap="round" />
                        <path d="M10.4852 1L1.99995 9" stroke="white" strokeWidth="2" strokeLinecap="round" />
                    </svg>

                    :
                    <>
                        <svg width="37" height="9" viewBox="0 0 37 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <line x1="37" y1="0.500031" x2="-2.31046e-08" y2="0.500024" stroke="white" />
                            <line x1="37" y1="8.50003" x2="-4.33211e-08" y2="8.50003" stroke="white" />
                        </svg>
                    </>

            }


        </StyledHamburger>
    );
};
const StyledHamburger = styled.div`
    cursor: pointer;
    transition: ${theme.transition};
    position: relative;

    svg {
        transition: ${theme.transition};
    }

    ${devices.sm} {
        svg{
            circle{
                fill: ${theme.colors.white} !important;
            }
        }
    }
    .text-content {
        position: relative;
        z-index: 3;
        color: ${theme.colors.white};
      
        p{
            font-weight: 600;
            font-size: 1rem;       /* 16px ÷ 16 */
            line-height: 1.25rem;  /* 20px ÷ 16 */
            letter-spacing: 0;     /* 0% = normal spacing */
            transition: ${theme.transition};

            ${devices.lgMd} {
                color: ${theme.colors.white} !important;
                
            }
        }
    }

    svg{
        transition: ${theme.transition};
        circle{
            transition: ${theme.transition};
            
        }
    }

    &:after, &:before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 1;
        transition: ${theme.transition};
    }

    &:hover {
        &:after {
            width: 100%;
            height: 100%;
            opacity: 1;
        }
    }

`
export default Hamburger;